export const checkMobileEnv = (ua) => {
  var ua = ua || (navigator && navigator.userAgent.toLowerCase()) || "";
  if (
    /mobile|android|iphone|ipad|phone|micromessenger|dingtalk/i.test(ua)
  ) {
    return true;
  }
  return false;
};
